import React from 'react'

function Best() {
  return (
    <div></div>
  )
}

export default Best